const defaultFeatureValues = {
  similarAlert: false,
  snoozeAlertMenu: false
}

export const getFeatureConfig = function(featureKey) {
  let featureValue = localStorage.getItem(featureKey);
  if(!featureValue) return defaultFeatureValues[featureKey] ;
  if(featureValue === 'true') {
      return true;
  }
  if(featureValue === 'false') {
      return false;
  }
  
  if(!isNaN(parseFloat(featureValue))) {
      return parseFloat(featureValue)
  }

  return featureValue
}
